import React, { useEffect, useState } from "react";
import { Popover, Typography, TextField, Button, Stack, Box, MenuItem, Grid, Autocomplete, Snackbar, Alert, Switch, FormControlLabel } from "@mui/material";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import DateInput from "./DateInput";
const FollowUpFilterModal = ({ anchorEl, open, onClose, onApply, onClear, connectionString }) => {
  const { selectedCompany, user } = useAuth();
  const uId = user?.UserId || null;
  const companyId = selectedCompany?.CompId || null;
  console.log("user", user)

  //  States
  const [statusOptions, setStatusOptions] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [sourceOptions, setSourceOptions] = useState([]);
  const [selectedSource, setSelectedSource] = useState(null);
  const [assigneeOptions, setAssigneeOptions] = useState([])
  const [selectedAssignee, setSelectedAssignee] = useState(null);
  const [priorityOptions, setPriorityOptions] = useState([]);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [clientOptions, setClientOptions] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null)
  const [clientSearch, setClientSearch] = useState("");
  const [clientLoading, setClientLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [userOptions, setUserOptions] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [area, setArea] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showOnlyMyFollowUps, setShowOnlyMyFollowUps] = useState(false);

  const toDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const [yyyy, mm, dd] = dateStr.split("-");
    // Add padStart to ensure two-digit format
    return `${dd.padStart(2, '0')}/${mm.padStart(2, '0')}/${yyyy}`;
  };

  const isValidDateRange = (from, to) => {
    if (!from || !to) return true; // Allow if either is empty
    return new Date(from) < new Date(to); // from < to
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };


  // 🔹 Apply handler
  // const handleApply = () => {
  //   const data = {};

  //   if (fromDate) data.fromDate = toDDMMYYYY(fromDate);
  //   if (toDate) data.toDate = toDDMMYYYY(toDate);
  //   if (selectedStatus) data.selectedStatus = selectedStatus.LeadStatusID;
  //   if (selectedUser) data.selectedUser = selectedUser.UserId;
  //   if (selectedSource) data.selectedSource = selectedSource.LeadsourceID;
  //   if (selectedAssignee) data.selectedAssignee = selectedAssignee.UserId;
  //   if (selectedClient) data.selectedClient = selectedClient.id;
  //   if (selectedPriority) data.selectedPriority = selectedPriority.id;
  //   if (area?.trim()) data.area = area.trim();

  //   if (fromDate && toDate && !isValidDateRange(fromDate, toDate)) {
  //     setSnackbarMessage("From Date must be less than To Date");
  //     setSnackbarOpen(true);
  //     return;
  //   }

  //   onApply(data);

  //   console.log(data);
  //   onApply?.(data);
  // };

  const handleApply = () => {
    const data = {};

    if (fromDate) data.fromDate = toDDMMYYYY(fromDate);
    if (toDate) data.toDate = toDDMMYYYY(toDate);
    if (selectedStatus) data.selectedStatus = selectedStatus.LeadStatusID;
    if (selectedUser) data.selectedUser = selectedUser.UserId;
    if (selectedSource) data.selectedSource = selectedSource.LeadsourceID;
    if (selectedAssignee) data.selectedAssignee = selectedAssignee.UserId;
    if (selectedClient) data.selectedClient = selectedClient.id;
    if (selectedPriority) data.selectedPriority = selectedPriority.id;
    if (area?.trim()) data.area = area.trim();

    // ✅ Add toggle value
    // data.showOnlyMyFollowUps = showOnlyMyFollowUps;
    data.dateType = showOnlyMyFollowUps ? "InquiryDate" : "FollowUpDate";

    if (fromDate && toDate && !isValidDateRange(fromDate, toDate)) {
      setSnackbarMessage("From Date must be less than To Date");
      setSnackbarOpen(true);
      return;
    }

    onApply?.(data);
  };

  // 🔹 Clear handler
  const handleClear = () => {
    setFromDate("");
    setToDate("");
    setSelectedClient(null);
    setSelectedStatus(null);
    setSelectedSource(null);
    setSelectedAssignee(null)
    setSelectedPriority(null);
    setSelectedUser(null);
    setArea("");
    setShowOnlyMyFollowUps(false);
    onClear?.();
  };

  useEffect(() => {
    if (userOptions.length && user?.UserId) {
      const defaultUser = userOptions.find(
        (u) => u.UserId === user.UserId
      );

      if (defaultUser) {
        setSelectedUser(defaultUser);
      }
    }
  }, [userOptions, user]);

  //Fetch all status
  const fetchStatus = () => {
    axios.get(`${connectionString}/api/leadStatus/get-status`, { params: { CompId: companyId } })
      .then(res => {
        const opts = (res.data.data || []).map(o => ({
          LeadStatusID: o.LeadStatusID,
          LeadStatus: o.LeadStatus.trim(),
        }));
        setStatusOptions(opts);
      })
      .catch(err => console.error("Error refetching status:", err));
  }

  //  Fetch all sources
  const fetchSources = () => {
    axios.get(`${connectionString}/api/sources`, { params: { companyId } })
      .then(res => setSourceOptions(res.data.data || []))
      .catch(err => console.error("Error refetching sources:", err));
  }

  //Fetch all assignees
  const fetchAssignees = () => {
    axios.get(`${connectionString}/api/users`, { params: { companyId: companyId, userId: uId } })
      .then(res => {
        const fetchedUsers = Array.isArray(res.data.data) ? res.data.data : [];
        console.log(fetchedUsers);
        setAssigneeOptions(fetchedUsers);
      })
  }

  //fetch all priorities
  const fetchPriorities = () => {
    axios.get(`${connectionString}/api/priority`)
      .then(res => {
        // console.log(res.data.data)
        if (res.data.data) {
          const transformedOptions = res.data.data.map(item => ({
            id: String(item.PriorityId),
            value: item.value
          }));
          setPriorityOptions(transformedOptions);
        } else {
          console.error("API returned success: false");
          setPriorityOptions([]); // Ensure empty array on failure
        }
      })
      .catch(error => {
        console.error("Error fetching priorities:", error);
        setPriorityOptions([]); // Ensure empty array on error
      });
  }

  // fetch all clients
  const fetchClients = async (searchText = "") => {
    if (!companyId) return;

    try {
      setClientLoading(true);

      const res = await axios.get(
        `${connectionString}/api/company-search`,
        {
          params: {
            field: "FirmName",
            search: searchText,
            companyId,
          },
        }
      );

      const data = Array.isArray(res.data.data) ? res.data.data : [];
      setClientOptions(data);
    } catch (err) {
      console.error("Error fetching clients:", err);
      setClientOptions([]);
    } finally {
      setClientLoading(false);
    }
  };

  //fetch all users
  useEffect(() => {
    if (companyId) {
      axios.get(`${connectionString}/api/users`, {
        params: {
          companyId: companyId,
          userId: uId
        }
      })
        .then(res => {
          console.log(res?.data?.data)
          if (res.data.data) { setUserOptions(res.data.data) }
        })
        .catch(error => {
          console.error("Error fetching users:", error);
        });
    }
  }, [])

  useEffect(() => {
    if (!companyId) return;
    fetchStatus();
    fetchSources();
    fetchAssignees();
    fetchPriorities();
    fetchClients("");
  }, [companyId]);


  return (
    <Popover open={open} anchorEl={anchorEl} onClose={onClose} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }} slotProps={{ paper: { sx: { p: 2, m: 1, width: 510, minHeight: 450, borderRadius: 2, }, }, }} >
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, textAlign: "center" }}>
        Filter By
      </Typography>

      <Grid item size={{ xs: 12 }}>
        <FormControlLabel
          control={
            <Switch
              checked={showOnlyMyFollowUps}
              onChange={(e) => setShowOnlyMyFollowUps(e.target.checked)}
              color="primary"
            />
          }
          label={showOnlyMyFollowUps ? "Inquiry Date" : "Follow Up Date"}
        />
      </Grid>

      <Grid container spacing={2}>
        {/* From Date */}
        <Grid item size={{ xs: 12, sm: 6 }}>
          <DateInput
            label="From Date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            error={fromDate && toDate && new Date(fromDate) >= new Date(toDate)}
            helperText={fromDate && toDate && new Date(fromDate) >= new Date(toDate) ? "Must be before To Date" : ""}
          />
        </Grid>

        {/* TO Date */}
        <Grid item size={{ xs: 12, sm: 6 }}>
          <DateInput label="To Date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
        </Grid>

        {/* Clients */}
        <Grid item size={{ xs: 12 }}>
          <Autocomplete fullWidth size="small" options={clientOptions} value={selectedClient} loading={clientLoading} getOptionLabel={(option) => option.FirmName || ""} noOptionsText={clientSearch ? "No client found" : "Start typing to search"} onChange={(event, newValue) => { setSelectedClient(newValue); }} onInputChange={(event, newInputValue) => { setClientSearch(newInputValue); fetchClients(newInputValue); }} ListboxProps={{ sx: { maxHeight: 200, overflowY: "auto", }, }}
            renderInput={(params) => (
              <TextField sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} {...params} label="Client Name" InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {clientLoading ? (
                      <span style={{ fontSize: 12 }}>Loading...</span>
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
              />
            )}
            renderOption={(props, option) => {
              const { key, ...rest } = props;
              return (
                <li key={option.id || key} {...rest}>
                  {option.FirmName}
                </li>
              );
            }}
          />
        </Grid>

        {/* users */}
        <Grid item size={{ xs: 12, sm: 6 }}>
          <Autocomplete fullWidth size="small" options={userOptions} getOptionLabel={(option) => option.employeeName || ""} value={selectedUser} onChange={(e, newValue) => { setSelectedUser(newValue); }} ListboxProps={{ sx: { maxHeight: 200, overflowY: "auto", }, }}
            renderInput={(params) => (
              <TextField {...params} label="Users" sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />)}
            renderOption={(props, option) => {
              const { key, ...rest } = props;
              return (
                <li key={option.UserId} {...rest}>
                  {option.employeeName}
                </li>
              );
            }}
          />
        </Grid>

        {/* assignee */}
        <Grid item size={{ xs: 12, sm: 6 }}>
          <Autocomplete fullWidth size="small" options={assigneeOptions} getOptionLabel={(option) => option.employeeName || ""} value={selectedAssignee} onChange={(e, newValue) => { setSelectedAssignee(newValue); }} ListboxProps={{ sx: { maxHeight: 200, overflowY: "auto", }, }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Assignee"
                sx={{
                  '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                  '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                }}
              />
            )}
            renderOption={(props, option) => {
              const { key, ...rest } = props;
              return (
                <li key={option.UserId} {...rest}>
                  {option.employeeName}
                </li>
              );
            }}
          />
        </Grid>

        {/* status */}
        <Grid item size={{ xs: 12, sm: 6 }}>
          <Autocomplete fullWidth ListboxProps={{ sx: { maxHeight: 200, overflowY: "auto", }, }} options={statusOptions} getOptionLabel={(option) => option.LeadStatus || ""} value={selectedStatus} onChange={(e, newValue) => { setSelectedStatus(newValue); }}
            renderInput={(params) => (
              <TextField {...params} label="Status" size="small" sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
            )}
            renderOption={(props, option) => {
              const { key, ...restProps } = props;

              return (
                <li key={key} {...restProps}>
                  {option.LeadStatus}
                </li>
              );
            }}

          />
        </Grid>

        {/* source */}
        <Grid item size={{ xs: 12, sm: 6 }}>
          <Autocomplete fullWidth size="small" options={sourceOptions} getOptionLabel={(option) => option.LeadSource || ""} value={selectedSource} onChange={(e, newValue) => { setSelectedSource(newValue); }} ListboxProps={{ sx: { maxHeight: 200, overflowY: "auto", }, }}
            renderInput={(params) => (
              <TextField {...params} label="Source" sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />)}
            renderOption={(props, option) => {
              const { key, ...rest } = props;
              return (
                <li key={key} {...rest}>
                  {option.LeadSource}
                </li>
              );
            }}
          />
        </Grid>

        {/* priority */}
        <Grid item size={{ xs: 12, sm: 6 }}>
          <Autocomplete fullWidth size="small" options={priorityOptions} getOptionLabel={(option) => option.value || ""} value={selectedPriority} onChange={(e, newValue) => { setSelectedPriority(newValue); }} ListboxProps={{ sx: { maxHeight: 200, overflowY: "auto", }, }}
            renderInput={(params) => (
              <TextField {...params} label="Priority" sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
            )}
            renderOption={(props, option) => {
              const { key, ...rest } = props;
              return (
                <li key={key} {...rest}>
                  {option.value}
                </li>
              );
            }}
          />
        </Grid>

        {/* Area  */}
        <Grid item size={{ xs: 12, sm: 6 }}>
          <TextField fullWidth size="small" label="Area" value={area} onChange={(e) => setArea(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
        </Grid>

        {/* Buttons */}
        <Grid item size={{ xs: 12 }}>
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <Button variant="contained" onClick={handleApply}> Apply </Button>
            <Button variant="outlined" color="error" onClick={handleClear}> Clear </Button>
          </Box>
        </Grid>
      </Grid>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity="error">
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </Popover>
  );
};

export default FollowUpFilterModal;